"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSummaryStore = void 0;
const services_1 = require("../services");
class CollectionSummaryStore {
    get(revision) {
        const rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByRevision(revision).value;
    }
    getLatest(revision) {
        const rest = services_1.Services.Department.rest;
        const summary = rest.CollectionSummary.getByRevision(revision).value;
        if (summary == null) {
            return null;
        }
        const latestSummary = rest.CollectionSummary.getByUuid(summary.uuid).value;
        if (latestSummary == null) {
            return null;
        }
        return latestSummary;
    }
    fetch(revision) {
        const rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByRevision(revision).fetch();
    }
    fetchByUuid(uuid) {
        const rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByUuid(uuid).fetch();
    }
    getFetchableByUuid(uuid) {
        const rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByUuid(uuid);
    }
}
exports.CollectionSummaryStore = CollectionSummaryStore;
//# sourceMappingURL=collection.summary.store.js.map